// أنماط الخريطة: متجهة (OpenFreeMap) وبديل صوري (raster) يعمل على كل الأجهزة بما فيها آيفون.
const BASE = "https://tiles.openfreemap.org/styles";

export const MAP_STYLES = {
  light: process.env.REACT_APP_MAP_STYLE_LIGHT || `${BASE}/liberty`,
  dark: process.env.REACT_APP_MAP_STYLE_DARK || `${BASE}/liberty`,
};

export const ATTRIBUTION = "© OpenStreetMap contributors";

// نمط صوري بلا ملف خارجي — يُستخدم عند فشل البلاطات المتجهة.
export const RASTER_STYLE = {
  version: 8,
  sources: {
    osm: {
      type: "raster",
      tiles: [
        "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png",
        "https://b.tile.openstreetmap.org/{z}/{x}/{y}.png",
        "https://c.tile.openstreetmap.org/{z}/{x}/{y}.png",
      ],
      tileSize: 256,
      maxzoom: 19,
      attribution: ATTRIBUTION,
    },
  },
  layers: [{ id: "osm", type: "raster", source: "osm" }],
};

export const DEFAULT_CENTER = { longitude: 55.2708, latitude: 25.2048 }; // دبي
export const DEFAULT_ZOOM = 15;

// نمط صور الأقمار الصناعية (Esri World Imagery) — مجاني بلا مفتاح، يعمل على كل الأجهزة.
export const SATELLITE_STYLE = {
  version: 8,
  sources: {
    sat: {
      type: "raster",
      tiles: ["https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"],
      tileSize: 256,
      maxzoom: 19,
      attribution: "Tiles © Esri — Source: Esri, Maxar, Earthstar Geographics",
    },
  },
  layers: [{ id: "sat", type: "raster", source: "sat" }],
};
